import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CardHeaderDirective } from './card-header.directive';

@Component({
  selector: 'pxw-card-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content />',
  standalone: true,
  host: {
    class: 'pxw-card-header',
  },
  hostDirectives: [CardHeaderDirective],
})
export class CardHeaderComponent {}
